// extracted by mini-css-extract-plugin
export default {"block":"TOqsB7z2ziFYfBL6xwR2","background":"tfq9Teo7WetlYiYDhV6o","button":"Qh5G_wRA1zEDdmOXPNZk"};